import React from 'react';
import GoogleMapReact from 'google-map-react';

const Map = ({ center, zoom }) => {
  return (
    <div style={{ height: '400px', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAP_API }}
        defaultCenter={center}
        defaultZoom={zoom}
      >
        {/* Marker example */}
        <Marker
          lat={center.lat}
          lng={center.lng}
          text="Your Place"
        />
      </GoogleMapReact>
    </div>
  );
};

const Marker = ({ text }) => <div><i className="fa-solid fa-location-dot me-2" style={{"font-size":"40px","color":"red"}}></i></div>;

export default Map;
